
import TestInstructionsStepFiveComponent from '@/components/Shared/RegisterTest/TestInstructionsStepFive/TestInstructionsStepFiveComponent';
export default TestInstructionsStepFiveComponent;
